import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Checkbox = ({ onChange, value, text, color }) => {
  return (
    <Root color={color}>
      <label className="toggle">
        <input
          className="toggle__input"
          type="checkbox"
          name="newsLetter"
          id="newsLetter"
          checked={value}
          onChange={onChange}
        />
        <span className="toggle__label">
          <span className="toggle__text">{text}</span>
        </span>
      </label>
    </Root>
  );
};

export default Checkbox;

Checkbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

const Root = styled.div`
  .toggle {
    --toggleColor: ${props => props.color};
    --toggleBgColor: ${props => props.color};
    --toggleSize: 22px;
  }

  .toggle {
    --uiToggleSize: var(--toggleSize, 20px);
    --uiToggleIndent: var(--toggleIndent, 0.4em);
    --uiToggleBorderWidth: var(--toggleBorderWidth, 1px);
    --uiToggleColor: var(--toggleColor, #000);
    --uiToggleDisabledColor: var(--toggleDisabledColor, #868e96);
    --uiToggleBgColor: var(--toggleBgColor, #fff);
    --uiToggleArrowWidth: var(--toggleArrowWidth, 2px);
    --uiToggleArrowColor: var(--toggleArrowColor, #fff);

    display: inline-block;
    position: relative;
  }

  .toggle__input {
    position: absolute;
    left: -99999px;
  }

  .toggle__label {
    display: inline-flex;
    cursor: pointer;
    min-height: var(--uiToggleSize);
    padding-left: calc(var(--uiToggleSize) + var(--uiToggleIndent));
  }

  .toggle__label:before,
  .toggle__label:after {
    content: '';
    box-sizing: border-box;
    width: 1em;
    height: 1em;
    font-size: var(--uiToggleSize);

    position: absolute;
    left: 0;
    top: 0;
  }

  .toggle__label:before {
    border: var(--uiToggleBorderWidth) solid var(--uiToggleColor);
    z-index: 2;
  }

  .toggle__input:disabled ~ .toggle__label:before {
    border-color: var(--uiToggleDisabledColor);
  }

  .toggle__input:not(:disabled) ~ .toggle__label:after {
    background-color: var(--uiToggleColor);
    opacity: 0;
  }

  .toggle__input:not(:disabled):checked ~ .toggle__label:after {
    opacity: 1;
  }

  .toggle__text {
    margin-top: auto;
    margin-bottom: auto;
  }

  .toggle__text:before {
    content: '';
    box-sizing: border-box;
    width: 0;
    height: 0;
    font-size: var(--uiToggleSize);

    border-left-width: 0;
    border-bottom-width: 0;
    border-left-style: solid;
    border-bottom-style: solid;
    border-color: var(--uiToggleArrowColor);

    position: absolute;
    top: 0.5428em;
    left: 0.2em;
    z-index: 3;

    transform-origin: left top;
    transform: rotate(-40deg) skew(10deg);
  }

  .toggle__input:not(:disabled):checked ~ .toggle__label .toggle__text:before {
    width: 0.5em;
    height: 0.25em;
    border-left-width: var(--uiToggleArrowWidth);
    border-bottom-width: var(--uiToggleArrowWidth);
    will-change: width, height;
    transition: width 0.1s ease-out 0.2s, height 0.2s ease-out;
  }

  /*
=====
LEVEL 2. PRESENTATION STYLES
=====
*/

  /* 
The demo skin
*/

  .toggle__label:before,
  .toggle__label:after {
    border-radius: 2px;
  }

  /* 
The animation of switching states
*/

  .toggle__input:not(:disabled) ~ .toggle__label:before,
  .toggle__input:not(:disabled) ~ .toggle__label:after {
    opacity: 1;
    transform-origin: center center;
    will-change: transform;
    transition: transform 0.2s ease-out;
  }

  .toggle__input:not(:disabled) ~ .toggle__label:before {
    transform: rotateY(0deg);
    transition-delay: 0.2s;
  }

  .toggle__input:not(:disabled) ~ .toggle__label:after {
    transform: rotateY(90deg);
  }

  .toggle__input:not(:disabled):checked ~ .toggle__label:before {
    transform: rotateY(-90deg);
    transition-delay: 0s;
  }

  .toggle__input:not(:disabled):checked ~ .toggle__label:after {
    transform: rotateY(0deg);
    transition-delay: 0.2s;
  }

  .toggle__text:before {
    opacity: 0;
  }

  .toggle__input:not(:disabled):checked ~ .toggle__label .toggle__text:before {
    opacity: 1;
    transition: opacity 0.1s ease-out 0.3s, width 0.1s ease-out 0.5s,
      height 0.2s ease-out 0.3s;
  }
`;
